import {
  isRoot,
  isContentManager,
  isDocumentManager,
  isLearningRequestManager,
  currentUserIsCompanyOwner
} from "@/plugins/roles";

export enum Roles {
  Root = "root",
  ContentManager = "contentManager",
  DocumentManager = "documentManager",
  CompanyOwner = "companyOwner",
  LearningRequestManager = "learningRequestManager"
}

export const checkRoles = (roles: Array<Roles> = []): boolean => {
  return !roles?.length ? true : checkAccess(roles);
};

const checkAccess = (roles: Array<Roles>): boolean => {
  const root = isRoot();
  const cm = isContentManager() && roles.includes(Roles.ContentManager);
  const dm = isDocumentManager() && roles.includes(Roles.DocumentManager);
  const co = currentUserIsCompanyOwner() && roles.includes(Roles.CompanyOwner);
  const lrm =
    isLearningRequestManager() && roles.includes(Roles.LearningRequestManager);

  return root || cm || dm || co || lrm;
};
